import { Link } from "react-router-dom";
import type { Work } from "@/types/gallery";
import { formatCount, getCategoryById } from "@/utils/gallery";

interface WorkCardProps {
  work: Work;
  index?: number;
}

export default function WorkCard({ work, index = 0 }: WorkCardProps) {
  const category = getCategoryById(work.categoryId);

  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300"
      style={{ animationDelay: `${(index % 8) * 60}ms` }}
      title={`${work.title} - ${work.model}写真作品`}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title} - 模特${work.model}${category ? category.name : ""}写真作品`}
          title={`${work.title} - ${work.model}写真作品`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-95" />
        {category && (
          <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900 backdrop-blur-sm">
            {category.name}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-4">
          <h3 className="text-base font-semibold text-white transition-colors duration-300 group-hover:text-primary-300">
            {work.title}
          </h3>
          <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-white/80">
            <span className="whitespace-nowrap">模特 {work.model}</span>
            <span className="hidden h-1 w-1 rounded-full bg-white/60 sm:block" />
            <span className="whitespace-nowrap">{work.date}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between px-4 py-3 text-xs text-foreground-600">
        <span className="flex items-center gap-1">
          <i className="ri-camera-lens-line text-sm text-primary-600" />
          {work.photographer}
        </span>
        <span className="flex items-center gap-3">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-sm" />
            {formatCount(work.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-3-line text-sm text-accent-500" />
            {formatCount(work.likes)}
          </span>
        </span>
      </div>
    </Link>
  );
}